import React from "react";

import { StyledDivider } from "./styles";
import { DividerProps } from "./types";

/**
 * Componente Divider
 *
 * Uma linha divisória estilizada com suporte para personalização de direção, espessura, cor e estilo.
 *
 * @param {'horizontal' | 'vertical'} [direction='horizontal'] - Define a orientação do Divider.
 * @param {string} [thickness] - Espessura da linha divisória.
 * @param {string} [color] - Cor personalizada para a linha.
 * @param {'solid' | 'dashed'} [styleType='solid'] - Estilo da linha: sólida ou tracejada.
 */
export const Divider: React.FC<DividerProps> = ({
  thickness,
  color,
  styleType = "solid",
  direction = "horizontal",
}) => {
  return (
    <StyledDivider
      direction={direction}
      thickness={thickness}
      color={color}
      styleType={styleType}
    />
  );
};
